var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1897_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.682461 15.9321C0.681711 18.6418 1.38971 21.2875 2.73596 23.6195L0.553711 31.5873L8.70771 29.4493C10.963 30.677 13.4899 31.3204 16.0577 31.3205H16.0645C24.5413 31.3205 31.4417 24.4226 31.4453 15.9443C31.447 11.8359 29.8485 7.97264 26.9442 5.06614C24.0405 2.15989 20.1786 0.558516 16.0638 0.556641C7.58596 0.556641 0.686086 7.45414 0.682586 15.9321",
    fill: "url(#paint0_linear_1897_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.13375 15.927C0.132875 18.7341 0.86625 21.4745 2.2605 23.89L0 32.1434L8.44637 29.9287C10.7736 31.1976 13.3939 31.8666 16.0601 31.8676H16.067C24.848 31.8676 31.9963 24.7216 32 15.9397C32.0015 11.6837 30.3455 7.68162 27.3375 4.671C24.3291 1.66075 20.3291 0.00175 16.067 0C7.2845 0 0.13725 7.145 0.13375 15.927ZM5.16388 23.474L4.8485 22.9734C3.52275 20.8654 2.823 18.4294 2.824 15.928C2.82675 8.62863 8.76725 2.69 16.072 2.69C19.6095 2.6915 22.934 4.0705 25.4345 6.5725C27.9349 9.07475 29.3108 12.401 29.3099 15.9388C29.3066 23.2381 23.366 29.1775 16.067 29.1775H16.0618C13.6851 29.1762 11.3542 28.538 9.3215 27.3319L8.83775 27.045L3.8255 28.3591L5.16388 23.474Z",
    fill: "url(#paint1_linear_1897_60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0845 9.26843C11.7862 8.60555 11.4723 8.59218 11.1887 8.58055C10.9565 8.57055 10.691 8.5713 10.4257 8.5713C10.1602 8.5713 9.72883 8.67118 9.3642 9.0693C8.9992 9.4678 7.9707 10.4308 7.9707 12.3894C7.9707 14.3482 9.39733 16.2411 9.5962 16.5069C9.79533 16.7723 12.3503 20.9203 16.3968 22.5161C19.7598 23.8422 20.4442 23.5784 21.1741 23.5119C21.9041 23.4457 23.5296 22.5492 23.8612 21.6196C24.1931 20.6901 24.1931 19.8933 24.0936 19.7268C23.9941 19.5609 23.7286 19.4613 23.3305 19.2623C22.9322 19.0632 20.975 18.1001 20.6101 17.9672C20.2451 17.8344 19.9797 17.7682 19.7142 18.1668C19.4487 18.5648 18.6863 19.4613 18.454 19.7268C18.2218 19.9929 17.9895 20.0261 17.5915 19.8269C17.1931 19.6272 15.911 19.2073 14.3898 17.8512C13.2063 16.7959 12.4073 15.4928 12.1751 15.0942C11.9428 14.6962 12.1502 14.4804 12.3498 14.2821C12.5287 14.1037 12.7481 13.8172 12.9473 13.5848C13.1458 13.3523 13.2121 13.1864 13.3448 12.9209C13.4777 12.6552 13.4112 12.4227 13.3118 12.2236C13.2121 12.0244 12.4385 10.0556 12.0845 9.26843Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1897_60",
    x1: 1545.14,
    y1: 3103.62,
    x2: 1545.14,
    y2: 0.556641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1897_60",
    x1: 1600,
    y1: 3214.34,
    x2: 1600,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1897_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.6cd99aa4a8ba37ed1b2abbf9d343eb81.svg";
export { ForwardRef as ReactComponent };